import { Component, EventEmitter, Output } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-custom-delete',
  templateUrl: './custom-delete.component.html',
  styleUrls: ['./custom-delete.component.css'],
})
export class CustomDeleteComponent {
  headerData: any;
  headerName = '';
  @Output() deleteCustom = new EventEmitter<any>();

  constructor(private modal: CustomModalService) {}

  ngOnInit(): void {
    this.headerData = this.modal?.modalService?.config?.initialState?.['headerName'];
    switch (this.headerData) {
      case 'customMaterial':
      case 'adminCustomMaterials':
        this.headerName = 'Delete confirmation for custom material';
        break;
      case 'customConversion':
      case 'adminCustomConversion':
        this.headerName = 'Delete confirmation for custom conversion';
        break;
      case 'customReuse':
      case 'adminCustomReuse':
        this.headerName = 'Delete confirmation for custom reuse';
        break;
      case 'customStorage':
      case 'adminCustomStorage':
        this.headerName = 'Delete confirmation for custom storage';
        break;
      case 'customTruck':
      case 'adminCustomTrucks':
        this.headerName = 'Delete confirmation for custom truck';
        break;
      case 'customFilling':
      case 'adminCustomFilling':
        this.headerName = 'Delete confirmation for custom filling';
        break;
      case 'customWaste':
      case 'adminWasteScenarios':
        this.headerName = 'Delete confirmation for custom waste scenario';
        break;
      case 'customTransport':
      case 'adminCustomTransport':
        this.headerName = 'Delete confirmation for custom transport scenario';
        break;
      case 'converting-processes':
        this.headerName = 'Delete confirmation for converting process';
        break;
      case 'adminOrganization':
        this.headerName = 'Delete confirmation for organization';
        break;
      case 'processing-data-conversion':
        this.headerName = 'Delete confirmation for conversion';
        break;
      case 'area-based-conversion':
        this.headerName = 'Delete confirmation for conversion';
        break;
      case 'admin-materials':
        this.headerName = 'Delete confirmation for material';
        break;
      case 'admin-ingredients':
        this.headerName = 'Delete confirmation for ingredient';
        break;
      case 'admin-recycled':
        this.headerName = 'Delete confirmation for RMI';
        break;
      case 'energy-and-ancillary':
        this.headerName = 'Delete confirmation for energy and ancillary';
        break;
      case 'Transport':
        this.headerName = 'Delete confirmation for transport mode ';
        break;
      case 'refrigareted-truck':
        this.headerName = 'Delete confirmation for transport mode ';
        break;
      case 'processing-custom-conversion':
        this.headerName = 'Delete confirmation for refrigerated truck';
        break;
      case 'processing-storage':
        this.headerName = 'Delete confirmation for storage';
        break;
      case 'processing-waste':
        this.headerName = 'Delete confirmation for waste';
        break;
      case 'processing-custom-truck':
        this.headerName = 'Delete confirmation for custom truck';
        break;
      case 'pallet-type':
        this.headerName = 'Delete confirmation for pallet type';
        break;
      case 'Project-Status':
        this.headerName = 'Delete confirmation for project status ';
        break;
      case 'scenario-status':
        this.headerName = 'Delete confirmation for scenario  status ';
        break;
      case 'misc-simulation':
        this.headerName = 'Delete confirmation for miscSimulation';
        break;
      default:
        break;
    }
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.deleteCustom.emit();
    this.onClose();
  }
}
